export default __webpack_public_path__ + "static/media/pause.37d121ae.svg";